import { BasicRequest } from "./basicRequest";

export class UndeleteCustomerRequest extends BasicRequest{

    public customerId! : number;
  
    constructor(){
        super();
    }
}